import Player from '@vimeo/player';
const YouTubeIframeLoader = require('youtube-iframe');

export default class VideoPlayer {
    constructor() {
        this.el = document.querySelector('.videoPlayer');
        this.innerEl = this.el.querySelector('.videoPlayer__inner');
        this.playButtons = document.querySelectorAll('.js-playVideo');
        this.player = false;
        this.type = false;
        this.loading = false;
        this.pausedBackgroundVideos = [];

        this.bindEvents();
    }

    bindEvents() {
        this.el.addEventListener('click', () => this.close());

        for (let i = 0; i < this.playButtons.length; i++) {
            const button = this.playButtons[i];
            button.addEventListener('click', () => this.playHandler(button));
        }
    }

    pausBackgroundVideos() {
        const videos = document.querySelectorAll('.videoHolder video');
        let pausedVidoes = [];

        for (let i = 0; i < videos.length; i++) {
            if (!videos[i].paused) {
                videos[i].pause();
                pausedVidoes.push(videos[i]);
            }
        }

        this.pausedBackgroundVideos = pausedVidoes;
    }

    resumeBackgrondVideos() {
        for (let i = 0; i < this.pausedBackgroundVideos.length; i++) {
            this.pausedBackgroundVideos[i].play();
        }

        this.pausedBackgroundVideos = [];
    }

    playHandler(element) {
        const url = element.getAttribute('data-video');
        this.type = this.setType(url);
        this.pausBackgroundVideos();
        document.body.classList.add('videoPlayer--active');

        if (this.type === 'vimeo') {
            this.playVimeo(url);
        } else if (this.type === 'youtube') {
            this.playYoutube(url);
        }
    }

    setType(url) {
        if (this.isYoutubeUrl(url) !== -1) {
            return 'youtube';
        } else if (this.isVimeoUrl(url) !== -1) {
            return 'vimeo';
        }
    }

    isYoutubeUrl(url) {
        return url.indexOf('youtube');
    }

    isVimeoUrl(url) {
        return url.indexOf('vimeo');
    }

    playYoutube(url) {
        const self = this;
        const videoId = this.getYoutubeId(url);

        YouTubeIframeLoader.load(function(YT) {
            self.player = new YT.Player('videoPlayer__inner', {
                videoId: videoId,
                height: '720',
                width: '1280',
                playerVars: {
                    'autoplay': 1,
                    'showinfo': 0,
                    'rel': 0
                }
            });
        });

        this.el.classList.add('is-active');
    }

    playVimeo(url) {
        this.loading = true;
        const self = this;

        const options = {
            url,
            width: 1280,
            autoplay: true,
            loop: false
        };

        if (!this.player) {
            this.player = new Player(this.innerEl, options);
        } else {
            const id = this.getVimeoId(url);
            this.player.loadVideo(id);
            this.player.play();
        }

        this.player.ready().then(function() {
            self.loading = false;
        });

        this.el.classList.add('is-active');
    }

    close() {
        if (this.loading) return;

        if (this.type === 'youtube') {
            this.player.stopVideo();
            this.player.destroy();
            this.player = false;
        } else if (this.type === 'vimeo') {
            setTimeout(() => {
                this.player.unload();
            }, 250);
        }

        document.body.classList.remove('videoPlayer--active');
        this.el.classList.remove('is-active');
        this.resumeBackgrondVideos();
        this.loading = false;
    }

    getVimeoId(url) {
        const match = /vimeo.*\/(\d+)/i.exec(url);

        if (match) {
            return match[1];
        }

        return false;
    }

    getYoutubeId(url) {
        url = url.split('?v=')[1];
        url = url.split('&')[0];

        return url;
    }
}



// WEBPACK FOOTER //
// ./src/components/videoPlayer/videoPlayer.js